import React from 'react';
import { useIsMaintenanceMode } from './hook/useIsMaintenanceMode';

interface MaintenanceScreenProps {
    children: React.ReactNode;
}

export const MaintenanceScreen = ({ children }: MaintenanceScreenProps) => {
    const { data, isLoading } = useIsMaintenanceMode({
        edgeConfigOptions: {
            edgeConfigId: 'ecfg_2jxeqmokoym9lwfuu2rmtfmnxvnt',
            edgeConfigToken: 'c3cbd141-f82d-45bd-a081-fd376b8379f0'
        }
    });

    if (isLoading) {
        return (
            <div className="w-full h-full flex items-center justify-center">
                <div>Loading...</div>
            </div>
        );
    }

    return data === true ? (
        <div className="w-full h-full flex flex-col items-center justify-center p-4">
            <span className="text-sm/4.75 text-center text-white">
                The game is temporarily down for maintenance.
                <br />
                Please try again later.
            </span>
        </div>
    ) : (
        children
    );
};
